<template>
  <div class="backdrop">
    <div class="relative w-full select-none">
      <div
        :class="{ '  text-secondary': path[0] == 'tests' }"
        @click="isOpen = !isOpen"
        ref="dropdown"
        class="w-full h-10 flex justify-between relative z-10 items-center pl-2 pr-4 base-selectinput cursor-pointer text-sm"
      >
        {{ selected }}
        <ChevronDownIcon class="w-5" />
      </div>
      <div
        v-if="isOpen"
        ref="selectFilter"
        class="w-full absolute top-[37px] z-30 bg-white rounded-br-lg rounded-bl-lg border-b border-r border-l border-secondary shadow-md"
      >
        <div class="flex flex-col">
          <div
            v-for="item in options"
            :key="item"
            class="text-sm hover:bg-secondary hover:text-white py-2 px-3 cursor-pointer select-none"
            :class="{
              'font-bold': item.text == selected && path[0] == 'tests',
            }"
            @click="onClicked(item)"
          >
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ChevronDownIcon } from "@heroicons/vue/solid";
import { onClickOutside } from "@vueuse/core";
const route = useRoute();
const path = route.path.split("/").splice(2, 1);
const isOpen = ref(false);
const dropdown = ref(null);
const selectFilter = ref(null);
onClickOutside(selectFilter, () => close());
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  value: {
    type: Number,
    required: true,
    default: 2,
  },
});
const emit = defineEmits(["onClick"]);
const filterStore = useProductStore();
const selected = ref();

const close = () => {
  isOpen.value = false;
};

watch(
  () => props.value,
  (newData) => {
    selected.value = props.options[newData].text;
  },
  { immediate: true },
);

onMounted(() => {
  // window.addEventListener("click", documentClick);
});
onBeforeUnmount(() => {
  // window.removeEventListener("click", documentClick);
});

function onClicked(data) {
  selected.value = data.text;
  isOpen.value = false;
  emit("onClick", data);
}
</script>
